const leisureSuggestions = {
  mini_low: [
    "Do a 4-7-8 breathing cycle",
    "Smell your favorite candle or perfume",
    "Look at funny memes or photos",
    "Close your eyes and listen to your surroundings for 1 minute",
    "Do 10 seconds of deep stretching"
  ],
  short_medium: [
    "Sketch a doodle with no pressure",
    "Try a 10-minute guided meditation",
    "Water your plants",
    "Make a comfort playlist",
    "Watch a YouTube video"
  ],
  medium_high: [
    "Put on music and dance it out",
    "Take a walk around the block",
    "Cook something fun but simple",
    "Rearrange a small corner of your space",
    "Call a loved one"
  ],
  long_any: [
    "Read a book or comic you enjoy",
    "Try a new recipe",
    "Watch a movie",
    "Do a slow creative task like painting",
    "Play a cozy video game"
  ]
};

export default leisureSuggestions;
